// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__mO4IW","small":"table_small__DLCcW"};